import React from 'react';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Warning from '@material-ui/icons/Warning';
import { Box, Button, Divider, Paper, Typography } from '@material-ui/core';
import { Tree } from '../components/Tree';
import { MappedTemplate } from '../types';
import { User } from '@app/shared/types';

interface UserDetailsSidebarProps {
  userData?: User;
  templates: MappedTemplate[];
  isLoading: boolean;
  handleEditUserWithData: (user: User) => void;
}

const UserDetailsSidebar = ({
  userData,
  templates,
  isLoading,
  handleEditUserWithData,
}: UserDetailsSidebarProps) => {
  return (
    <Paper style={{ height: '100%' }}>
      {!isLoading && (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            style={{ padding: '30px 48px' }}
          >
            <Typography variant="h6" color="textPrimary">
              {userData?.username}
            </Typography>

            <Box display="flex" alignItems="center" style={{ gap: 16 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (userData) {
                    handleEditUserWithData(userData);
                  }
                }}
              >
                Edit User
              </Button>
              <Typography
                variant="body1"
                color="textPrimary"
                style={{
                  fontSize: 14,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                }}
              >
                {userData?.isActive ? (
                  <>
                    <CheckCircle htmlColor="green" /> Active
                  </>
                ) : (
                  <>
                    <Warning color="error" />
                    Deactivated
                  </>
                )}
              </Typography>
            </Box>
          </Box>
          <Divider />

          <Box
            display="flex"
            style={{ padding: '40px 48px' }}
            flexDirection="column"
          >
            <Typography variant="h6" color="textPrimary">
              Permissions
            </Typography>
            <Box
              display="flex"
              flexDirection="row"
              flexWrap="wrap"
              style={{ gap: 8, marginTop: 16 }}
            >
              <Tree
                value={userData?.attributes}
                templates={templates}
                isDisabled
              />
            </Box>
          </Box>
        </>
      )}
    </Paper>
  );
};

export default UserDetailsSidebar;
